import { Link } from "react-router-dom";
import styles from "./ReturnReview.module.scss";
import {
  convertToTilteCase,
  defaultDateDisplay,
  formatCurrency,
} from "../../../../../helpers";
import { pathConstants } from "../../../../../routes/pathContants";

export const ReturnDetailsCard = ({
  returnDetails = {},
  currencyCode: currencyCodeProp,
  orderId: orderIdProp,
  customerName: customerNameProp,
  customerId: customerIdProp,
  submittedByName: submittedByNameProp,
  totalAmount: totalAmountProp,
  refundableAmount: refundableAmountProp,
  deliveryFee: deliveryFeeProp,
  serviceCharge: serviceChargeProp,
  isApproved: isApprovedProp,
  isRejected: isRejectedProp,
  className = "",
  style,
}) => {
  const status = returnDetails?.status || "REVIEW";
  const isApproved = isApprovedProp ?? status === "APPROVED";
  const isRejected = isRejectedProp ?? status === "REJECTED";

  const currencyCode =
    currencyCodeProp || returnDetails?.store?.currency_code || "NGN";

  const orderId =
    orderIdProp ?? (returnDetails?.order?.id || returnDetails?.order);
  const customerName =
    customerNameProp ??
    (returnDetails?.customer?.full_name ||
      returnDetails?.order?.customer?.full_name);
  const customerId =
    customerIdProp ??
    (returnDetails?.customer?.id || returnDetails?.order?.customer?.id);
  const submittedByName =
    submittedByNameProp ??
    (returnDetails?.submitted_by?.full_name ||
      returnDetails?.cashier?.first_name ||
      "-");
  const totalAmount =
    totalAmountProp ??
    (returnDetails?.total_requested_amount ||
      returnDetails?.total_returned_amount ||
      0);
  const deliveryFee =
    deliveryFeeProp ??
    returnDetails?.total_requested_delivery_fee ??
    returnDetails?.total_returned_delivery_fee ??
    0;
  const serviceCharge =
    serviceChargeProp ??
    returnDetails?.total_requested_service_charge ??
    returnDetails?.total_returned_service_charge ??
    0;
  const refundableAmount =
    refundableAmountProp ??
    returnDetails?.refundable_amount ??
    Number(totalAmount) + Number(deliveryFee) + Number(serviceCharge);

  return (
    <div
      className={`${styles.returnReview__card} ${className}`.trim()}
      style={style}
    >
      <div>
        <h6>Order Number</h6>
        <p>
          {orderId ? (
            <Link
              to={`${pathConstants.INVENTORY_SALES_TRANSACTIONS}?orderId=${orderId}`}
              className="purple--text"
              style={{ textDecoration: "underline" }}
            >
              #{orderId}
            </Link>
          ) : (
            "-"
          )}
        </p>
      </div>

      <div>
        <h6>Store Name</h6>
        <p>{returnDetails?.store?.name || "-"}</p>
      </div>

      <div>
        <h6>Currency</h6>
        <p>{currencyCode}</p>
      </div>

      <div>
        <h6>Return Date & Time</h6>
        <p>{defaultDateDisplay(returnDetails?.return_date)}</p>
      </div>

      <div>
        <h6>Submitted By</h6>
        <p>{submittedByName}</p>
      </div>

      <div>
        <h6>Customer</h6>
        <p>
          {customerName ? (
            customerId ? (
              <Link
                to={pathConstants.CUSTOMER_DETAILS({
                  customerId,
                })}
                className="purple--text"
                style={{ textDecoration: "underline" }}
              >
                {customerName}
              </Link>
            ) : (
              customerName
            )
          ) : (
            "N/A"
          )}
        </p>
      </div>

      <div>
        <h6>Refund Method</h6>
        <p>
          {returnDetails?.payment_method
            ? convertToTilteCase(
                returnDetails?.payment_method?.replace(/_/g, " "),
              )
            : "N/A"}
        </p>
      </div>

      <div>
        <h6>Total Returned Amount</h6>
        <p style={{ color: "#27AE60" }}>
          {formatCurrency({
            value: totalAmount,
            currencyCode,
          })}
        </p>
      </div>

      {Number(serviceCharge) > 0 && (
        <div>
          <h6>Service Charge Refund</h6>
          <p style={{ color: "#27AE60" }}>
            {formatCurrency({
              value: serviceCharge,
              currencyCode,
            })}
          </p>
        </div>
      )}

      {Number(deliveryFee) > 0 && (
        <div>
          <h6>Delivery Fee Refund</h6>
          <p style={{ color: "#27AE60" }}>
            {formatCurrency({
              value: deliveryFee,
              currencyCode,
            })}
          </p>
        </div>
      )}

      <div>
        <h6>Refundable Amount</h6>
        <p>
          {formatCurrency({
            value: refundableAmount,
            currencyCode,
          })}
        </p>
      </div>

      <div>
        <h6>Staff Remarks / Reason</h6>
        <p>{returnDetails?.remarks || "None provided"}</p>
      </div>

      {isApproved && returnDetails?.reviewed_by && (
        <div>
          <h6>Approved By</h6>
          <p>{returnDetails.reviewed_by.full_name || "N/A"}</p>
        </div>
      )}

      {isApproved && returnDetails?.reviewed_at && (
        <div>
          <h6>Approved At</h6>
          <p>{defaultDateDisplay(returnDetails.reviewed_at)}</p>
        </div>
      )}

      {isRejected && returnDetails?.reviewed_by && (
        <div>
          <h6>Rejected By</h6>
          <p>{returnDetails.reviewed_by.full_name || "N/A"}</p>
        </div>
      )}

      {isRejected && returnDetails?.reviewed_at && (
        <div>
          <h6>Rejected At</h6>
          <p>{defaultDateDisplay(returnDetails.reviewed_at)}</p>
        </div>
      )}
    </div>
  );
};

export { ReturnDetailsCard as ReturnReviewDetails };
export default ReturnDetailsCard;
